// Modules
import {FC} from "react";
import { Provider } from "react-redux";
import wrapper from "redux/store";

// Imported definitions
import type { AppProps } from "next/app";

// styles
import "styles/font-awesome.min.css";
import "styles/wk-icons-all-open.min.css";
import "styles/altalex-style.css";
import "styles/custom-altalex-style.css";
import "styles/wk-listing-page-altalex.css";
import "styles/searchBar.css";
import "styles/searchBarAltalex.css";
import "styles/pagination.css";
import "styles/sidebar.css";
import "styles/product.css";
import "styles/banner.css";


const App: FC<AppProps> = ({Component, ...rest}) => {
	const {store, props} = wrapper.useWrappedStore(rest);
	return (
		<Provider store={store}>
			<Component {...props.pageProps} />
		</Provider>
	);
};

export default App;
